
import debounce from '~/mixins/debounce'
export default {

    props: {
        filters: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
        searchFilter() {
            return this.filters.find((filter) => filter.type === 'search')
        },
        tagFilter() {
            return this.filters.find((filter) => filter.type === 'tags')
        },
        onlySearch() {
            return this.searchFilter && !this.tagFilter
        },
        // locationFilter() {
        //     return this.filters.find((filter) => filter.type === 'location-select')
        // },
        // taxonomyFilter() {
        //     return this.filters.find((filter) => filter.type === 'taxonomy-select')
        // },
        search: {
            get() {
                if (!this.searchFilter) return
                const value = this.$route.query[this.searchFilter.key]
                if (value?.includes('/')) {
                    const parts = value.split('/')
                    if (parts?.length > 1) return { slug: parts[0] || undefined, name: parts[1] || undefined }
                }
                return value
            },
            set(value) {
                this.setSearch(value)
            },
        },
        // location: {
        //     get() {
        //         if(!this.i) return
        //         const value = this.$route.query[this.locationFilter.key]
        //         if (value?.includes('/')) {
        //             const parts = value.split('/')
        //             if (parts && parts.length > 1) return { slug: parts[0] || undefined, name: parts[1] || undefined }
        //         }
        //         return value
        //     },
        //     set(value) {
        //         const query = JSON.parse(JSON.stringify(this.$route.query))
        //         if (value?.meta?.val) {
        //             query['meta-key'] = v.meta.key
        //             query['meta-val'] = v.meta.val
        //         } else {
        //             query['meta-key'] = undefined
        //             query['meta-val'] = undefined
        //         }
        //         this.$router.replace({ params: this.$route.params, query })
        //     },
        // },
        // taxonomy: {
        //     get() {
        //         if(!this.taxonomyFilter) return
        //         const value = this.$route.query[this.taxonomyFilter.key]
        //         if (value?.includes('/')) {
        //             const parts = value.split('/')
        //             if (parts && parts.length > 1) return { slug: parts[0] || undefined, name: parts[1] || undefined }
        //         }
        //         return value
        //     },
        //     set(value) {
        //         const query = JSON.parse(JSON.stringify(this.$route.query))
        //         if (v?.slug) {
        //             if (query[this.taxonomyFilter.key] !== value.slug) {
        //                 query[this.taxonomyFilter.key] = `${value.slug}/${value.name}`
        //             }
        //         } else query[this.taxonomyFilter.key] = undefined
        //         this.$router.replace({ params: this.$route.params, query })
        //     },
        // },
    },
    methods: {
        open() {
            this.isOpen = true
        },
        close() {
            this.isOpen = false
        },
        onClear(){
            if(this.search) this.search = undefined
        },

        setSearch: debounce(function (value) {
            const query = JSON.parse(JSON.stringify(this.$route.query))
            if (query[this.searchFilter.key] !== value) {
                query[this.searchFilter.key] = value || undefined
                this.$router.replace({ params: this.$route.params, query })
            }
        }, 500),
    },
}
